import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { ScanMode } from '../models';
import {
  BarcodeScannedAction,
  barcodeScannedAction,
  closeIfScannerIsShownAction,
  closeScannerCameraAction,
  pauseScanningAction,
  restartScanningAction,
  resumeScanningAction,
  scannerStateChangedAction,
  showScannerCameraAction,
  showTemporaryClosedScannerCameraAction,
  startScanningAction,
  stopScanningAction,
} from './scanner.actions';
import { IScannerFeature } from './scanner.feature.state';
import {
  getFailures,
  getIsContinuousScan,
  getIsLoading,
  getIsScannerShown,
  getIsScannerStarted,
  getScannerShouldRestart,
  getTemporaryClosedDetails,
} from './scanner.selectors';

@Injectable()
export class ScannerFacade {
  public isLoading$ = this.store.select(getIsLoading);
  public failures$ = this.store.select(getFailures);
  public isContinuousScan$ = this.store.select(getIsContinuousScan);
  public scannerShouldRestart$ = this.store.select(getScannerShouldRestart);
  public isScannerStarted$ = this.store.select(getIsScannerStarted);
  public isScannerShown$ = this.store.select(getIsScannerShown);
  public temporaryClosedDetails$ = this.store.select(getTemporaryClosedDetails);

  constructor(private store: Store<IScannerFeature>) {}

  public barcodeScanned(barcode: string): void {
    this.store.dispatch(barcodeScannedAction({ barcode }));
  }

  public showScannerCamera(scanMode: ScanMode, actionToDispatchOnBarcodeScanned: BarcodeScannedAction): void {
    this.store.dispatch(showScannerCameraAction({ scanMode, actionToDispatchOnBarcodeScanned }));
  }

  public showTemporaryClosedScannerCamera(): void {
    this.store.dispatch(showTemporaryClosedScannerCameraAction());
  }

  public closeIfScannerIsShown(): void {
    this.store.dispatch(closeIfScannerIsShownAction());
  }

  public closeScannerCamera(isTemporaryClosed = false): void {
    this.store.dispatch(closeScannerCameraAction({ isTemporaryClosed }));
  }

  public startScanning(): void {
    this.store.dispatch(startScanningAction());
  }

  public pauseScanning(): void {
    this.store.dispatch(pauseScanningAction());
  }

  public resumeScanning(): void {
    this.store.dispatch(resumeScanningAction());
  }

  public stopScanning(): void {
    this.store.dispatch(stopScanningAction());
  }

  public restartScanning(): void {
    this.store.dispatch(restartScanningAction());
  }

  public scannerStateChanged(scannerState: Scandit.BarcodePicker.State): void {
    this.store.dispatch(scannerStateChangedAction({ scannerState }));
  }

  public dispathCustomActionOnBarcodeScanned(action: BarcodeScannedAction, barcode: string): void {
    this.store.dispatch(action({ barcode }));
  }
}
